export default [
    {
        mediaName: 'Instagram',
        mediaUrl: 'https://www.instagram.com/xunpat/'
    },
    {
        mediaName: 'Codepen',
        mediaUrl: 'https://codepen.io/patrickxunuo/'
    },
    {
        mediaName: 'Github',
        mediaUrl: 'https://github.com/patrickxunuo',
    },
    {
        mediaName: 'Gitlab',
        mediaUrl: 'https://gitlab.com/patrickxun',
    },
    {
        mediaName: 'Linkedin',
        mediaUrl: 'https://www.linkedin.com/in/patrick-xu-46922813a/',
    },
    {
        mediaName: 'Youtube',
        mediaUrl: 'https://www.youtube.com/channel/UCS5GFXP__1KDooflPMz_vFg/videos',
    },
    {
        mediaName: 'Facebook',
        mediaUrl: 'https://www.facebook.com/patrick.hui.9028/',
    },
    {
        mediaName: 'Twitter',
        mediaUrl: 'https://twitter.com/ecc9e7a260844b5'
    }
]

